export default "__VITE_ASSET__Cd5WZmVA__"